'use strict';

iceBlockUi.$inject = ['$parse'];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = iceBlockUi;
function iceBlockUi($parse) {
  'ngInject';

  return {
    restrict: 'A',
    replace: false,
    scope: false, // osserva e valuta @iceBlockUi, usa evenutalmente il selettore @blockTarget
    link: function link(scope, elem, attrs) {

      var blocking = false;
      var options = {
        message: null,
        overlayCSS: { backgroundColor: '#fff' }
      };

      scope.$watch(function () {
        return $parse(attrs.iceBlockUi)(scope);
      }, function (newValue) {

        var targetElement;
        if (attrs.blockTarget) {
          targetElement = elem.find(attrs.blockTarget);
        }
        if (!targetElement) {
          targetElement = elem;
        }

        if (newValue) {
          blocking = true;
          targetElement.block(options);
        } else {
          blocking = false;
          targetElement.unblock();
        }
      });

      scope.$on('$destroy', function () {
        if (blocking) {
          elem.unblock();
        }
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.ui/blockUI.directive.js
// module id = 139
// module chunks = 2